import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { CheckStatusType } from '../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';
import { CheckType } from '../../../../../api/types/reports/accountant/check.type';
import { updateCheckStatusOperation } from '../operations/update-check-status-operation';

interface UpdateStatusCheckDialogProps {
  visible: boolean;
  onHide: () => void;
  check: CheckType;
  onStatusUpdated: () => void;
}

export const UpdateStatusCheckDialog: React.FC<
  UpdateStatusCheckDialogProps
> = ({ visible, onHide, check, onStatusUpdated }) => {
  const [selectedStatus, setSelectedStatus] = useState<CheckStatusType>(
    check.checkStatus,
  );
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { label: 'ממתין להפקדה', value: CheckStatusType.PENDING },
    { label: 'הופקד', value: CheckStatusType.DEPOSITED },
    { label: 'פורע', value: CheckStatusType.CLEARED },
    { label: 'נדחה', value: CheckStatusType.BOUNCED },
    { label: 'בוטל', value: CheckStatusType.CANCELLED },
    { label: 'פג תוקף', value: CheckStatusType.EXPIRED },
  ];

  const handleApprove = async () => {
    if (!selectedStatus) return;

    try {
      await updateCheckStatusOperation(
        check.paymentId,
        check.checkId,
        selectedStatus,
        setLoading,
      );
      onStatusUpdated();
    } catch (error) {
      console.error('Error updating check status:', error);
    }
  };

  const isStatusChanged = selectedStatus !== check.checkStatus;

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="עדכון סטטוס המחאה"
      modal
      style={{ width: '500px' }}
      footer={
        <div
          style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}
        >
          <Button label="ביטול" outlined onClick={onHide} disabled={loading} />
          <Button
            label="אישור"
            loading={loading}
            disabled={!isStatusChanged}
            onClick={handleApprove}
          />
        </div>
      }
    >
      <div style={{ padding: '20px 0' }}>
        <div style={{ marginBottom: '20px', textAlign: 'right' }}>
          <p style={{ fontSize: '16px', color: '#333' }}>
            יש לבחור את סטטוס ההמחאה המבוקשת
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label
            htmlFor="checkStatus"
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold',
              textAlign: 'right',
            }}
          >
            סטטוס המחאה:
          </label>
          <Dropdown
            id="checkStatus"
            value={selectedStatus}
            options={statusOptions}
            onChange={(e) => setSelectedStatus(e.value)}
            placeholder="בחר סטטוס"
            style={{ width: '100%', textAlign: 'right' }}
            disabled={loading}
          />
        </div>

        <div
          style={{
            padding: '15px',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            textAlign: 'right',
          }}
        >
          <div style={{ marginBottom: '8px' }}>
            <strong>פרטי המחאה:</strong>
          </div>
          <div>מספר המחאה: {check.checkNumber}</div>
          <div>בנק: {check.bankNumber}</div>
          <div>סניף: {check.branchNumber}</div>
          <div>חשבון: {check.accountNumber}</div>
          <div>סכום: ₪{check.paymentAmount}</div>
        </div>
      </div>
    </Dialog>
  );
};
